<template>
    <!-- <OverlayLoader :isLoading="!true">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('general.dashboard')"
                    icon="fal fa-search"
                    @iconClicked="toggleSearch"
                />

                <AdminResellersBlocks
                    :resellers="resellers"
                    @deleteReseller="deleteReseller"
                    @deactivateReseller="deactivateReseller"
                />
            </div>

            <FloatingButton
                @clicked="$router.push({ name: 'Admin Resellers Add' })"
            />
        </main>
    </OverlayLoader> -->
    <OverlayLoader :isLoading="!true">
        <main class="page page-dashboard">
            <div class="container">
                <div class="head row" >
                    <div class="col-sm-12" v-if="language === 'nl_NL'">
                        <h2>
                            De Online Shopconnector is een krachtige universele applicatie voor het
                            vullen én onderhouden van een webshop.
                        </h2>
                        <br/>
                        Door gebruik te maken van de Online Shopconnector kunnen prijzen, voorraad,
                        productinformatie en prijsmarges snel en nauwkeurig doorgevoerd worden in uw
                        webshop. Het is mogelijk om diverse soorten bestanden, zoals XML, CSV en
                        Excel, in te lezen maar ook een directe koppeling tussen de
                        Onlineshopconnector en een ERP-pakket behoort tot de mogelijkheden. Ook is
                        het mogelijk om productinformatie en afbeeldingen verder aan te vullen met
                        een content managementsysteem zoals Icecat.
                        <br/><br/>
                        De grote kracht van de Online Shopconnector:<br/><br/>
                        - grote flexibiliteit<br/>
                        - snelle verwerking<br/>
                        - instellen prijsmarges<br/>
                        - keuze welke producten of merken wel of niet in webshop komen<br/>
                        - actuele voorraad inzien<br/>
                        - automatisch verwijderen van producten zodra deze bij de leverancier niet meer beschikbaar zijn<br/>
                        - bijna onbeperkte mogelijkheden<br/><br/>

                        <h3>
                            Uw webshop altijd voorzien van de juiste producten en informatie!
                        </h3>
                    </div>
                    <div class="col-sm-12" v-if="language === 'en_EN'">
                        <h2>
                            The Online Shopconnector is a powerful universal application for filling and maintaining a webshop.
                        </h2>
                        <br/>
                        By using the Online Shopconnector, prices, stock, product information and price margins can be implemented quickly and accurately in your webshop.
                        It is possible to read various types of files, such as XML, CSV and Excel, but also a direct link between the online shop connector and an ERP package is possible.
                        It is also possible to further supplement product information and images with a content management system such as Icecat.
                        <br/><br/>
                        The great power of the Online Shop connector:<br/><br/>
                        - great flexibility<br/>
                        - fast processing<br/>
                        - set price margins<br/>
                        - choice of which products or brands will or will not enter the webshop<br/>
                        - view current stock<br/>
                        - automatic removal of products as soon as they are no longer available at the supplier<br/>
                        - almost unlimited options<br/><br/>
                        <h3>
                            Always provide your webshop with the right products and information!
                        </h3>
                    </div>
                    <div class="col-sm-12" v-if="language === 'de_DE'">
                        <h2>
                            Der Online Shopconnector ist eine leistungsfähige Universal-Anwendung, um einen Webshop zu ergänzen und zu pflegen.
                        </h2>
                        <br/>
                        Mit dem Online Shopconnector können Preise, Lagerbestände, Produktinformationen und Preisspannen schnell und präzise in Ihrem Webshop implementiert werden.
                        Verschiedene Dateitypen wie XML, CSV und Excel können mit dem Online Shopconnector eingelesen werden,
                        aber auch eine direkte Verknüpfung zwischen dem Online Shopconnector und einem ERP-System ist möglich.
                        Produktinformationen und Bilder können mit einem Content-Management-System wie Icecat zu ergänzt werden.
                        <br/><br/>
                        Die großen Vorteile und Möglichkeiten mit dem Online Shopconnector:<br/><br/>
                        - große Flexibilität<br/>
                        - schnelle Verarbeitung<br/>
                        - Preisspannen festlegen<br/>
                        - einfache Auswahl, welche Produkte oder Marken in den Webshop eingepflegt werden oder nicht<br/>
                        - Anzeige der aktuellen Lagerbestände<br/>
                        - automatische Entnahme von Produkten, sobald diese beim Lieferanten nicht mehr verfügbar sind<br/>
                        - fast unbegrenzte Möglichkeiten<br/><br/>

                        <h3>
                            Ihr Shop zeigt immer die aktuellen Produkte und Informationen!
                        </h3>
                    </div>
                </div>
                <div class="content row" style="margin-top:32px;">
                    <div class="col-sm-12" style="display:flex;">
                        <div class="col-sm-6" >
                            <h2>{{ t('general.current.customers') }}</h2>
                            <div class="form-submit col-sm-8 no-padding">
                                <button
                                    @click="goToLogin()"
                                    class="button button--rounded"
                                >
                                    {{ t('auth.login') }}
                                </button>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <h2>{{ t('general.register') }}</h2>


                            <div class="form-submit col-sm-8 no-padding">
                                <button
                                    @click="goToRegister()"
                                    class="button button--rounded"
                                >
                                    {{ t('general.register') }}
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row" style="display:flex; margin-top:100px;">
                    <div class="col-sm-12">
                        <h2>{{ t('general.supported.software') }}</h2>
                    </div>
                    <div class="col-sm-12 justify-content-between" style="display:flex; margin-top:16px;">

                        <div class="col-sm-3 col-sm-offset-1 connector-logo">
                            <img src="@/assets/sw-logo.svg" class="dashboard-img" alt="Shopware" style="width:200px;" />
                        </div>

                        <div class="col-sm-3 col-sm-offset-1 connector-logo">
                            <img src="@/assets/magento-logo.svg" class="dashboard-img" alt="Magento" style="width:200px; padding: 20px;" />
                        </div>

                        <div class="col-sm-3 col-sm-offset-1 connector-logo" >
                            <img src="@/assets/woocommerce-logo.png" class="dashboard-img" alt="Woocommerce" style="width:200px;"  />
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </OverlayLoader>

</template>
<script>

import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';

export default {
    name: 'dashboard',

    components: {
        OverlayLoader,
    },

    methods: {
        goToLogin() {
            this.$router.push('/login');
        },

        goToRegister() {
            this.$router.push('/register');
        },
    },

    computed: {
        language() {
            return this.$translate.current;
        },
    },
};
</script>
<style lang="scss" scoped>
.form-submit {
    display: flex;
    align-items: center;
    margin-top:16px;

    div {
        flex: 2;

        a {
            color: $yellow;
            text-decoration: none;
            display: inline;
        }
    }

    button {
        flex: 6;
        width: 100%;
    }

}

.connector-logo {
    text-align: center;
    border: 1px solid #A0B3C4;
    background: white;
    border-radius: 8px;
    transition: 0.3s;
    position: relative;
    height: 70px;
}

// Need to overwrite the other css with these classes below
.disabled {
    background-color: $blue-light;
    cursor: not-allowed !important;
    border: 1px solid $blue-light;
    &:hover {
        background-color: $blue-light;
        border: 1px solid $blue-light;
        cursor: not-allowed !important;
    }

    &:focus {
        outline: none;
        background-color: $blue-light;
        border: 1px solid $blue-light;
        cursor: not-allowed !important;
    }
}

.testing {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 40%;
}

.content {
    .col-sm-6:first-child {
        padding-left: 0px;
    }
    .col-sm-6:last-child {
        padding-right: 0px;
    }
}

.no-padding {
    padding: 0px;
}

.dashboard-img {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%)
}
</style>
